export const TABLE_PAGE_SIZES = [20, 50, 100, 250]

export const TABLE_FILTER_DATE_FORMAT: string = 'yyyy-MM-dd'
